import type { DriverListResponse } from '@contracts/driver/DriverListResponse';
import type { DriverRequest } from '@contracts/driver/DriverRequest';
import type { DriverResponse } from '@contracts/driver/DriverResponse';
import { AuthenticatedClient } from '@src/common/services/AuthenticatedClient';
import { DriverList } from '@src/driver/domain/DriverList';

export const DriversClient = {
  list: async (clientId: string): Promise<DriverListResponse> => {
    const { data: response } =
      await AuthenticatedClient.get<DriverListResponse>(
        `clients/${clientId}/drivers`,
      );

    return new DriverList(response.drivers);
  },
  get: async (
    clientId: string,
    driverId: string,
  ): Promise<DriverResponse | null> => {
    const { data: response } = await AuthenticatedClient.get<DriverResponse>(
      `clients/${clientId}/drivers/${driverId}`,
    );

    return response;
  },
  create: async (
    clientId: string,
    data: DriverRequest,
  ): Promise<DriverResponse> => {
    const { data: response } = await AuthenticatedClient.post<DriverResponse>(
      `clients/${clientId}/drivers`,
      data,
    );

    return response;
  },
  update: async (
    clientId: string,
    driverId: string,
    data: DriverRequest,
  ): Promise<DriverResponse> => {
    const { data: response } = await AuthenticatedClient.put<DriverResponse>(
      `clients/${clientId}/drivers/${driverId}`,
      data,
    );

    return response;
  },
  delete: async (clientId: string, driverId: string): Promise<void> => {
    await AuthenticatedClient.post<void>(
      `clients/${clientId}/drivers/${driverId}/delete`,
    );
  },
};
